// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZramSingleFamilyWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_Path,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_list,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_Path,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_options,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_Path,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_Path,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_Path,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_status,
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_Path,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  AccountViewListingAdproductDto,
  AccountViewListingOptionsDto,
  AccountViewListingProspectsDto,
  AccountViewListingsDto,
  AccountViewListingSourcesDto,
  AccountViewListingStatusOverviewDto,
  ListingAlias,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface AdvertisingParams {
  listingAlias: ListingAlias;
}
interface ListParams {
  includeActive?: boolean;
  includeArchived?: boolean;
  includeAtRiskOnly?: boolean;
  includeInactive?: boolean;
  includeListingCounts?: boolean;
  includeSpotlightedOnly?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  offset?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface OptionsParams {
  listingAlias: ListingAlias;
}
interface ProspectsParams {
  listingAlias: ListingAlias;
}
interface SourcesParams {
  listingAlias: ListingAlias;
}
interface StatusParams {
  listingAlias: ListingAlias;
}

export type RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_Options = UseQueryOptions<
  AccountViewListingAdproductDto,
  unknown,
  AccountViewListingAdproductDto,
  readonly [string, AdvertisingParams]
>;

const RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_GetKey = (getParams: AdvertisingParams) =>
  [RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_Path, getParams] as const;

export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_queryOptions = (
  getParams: AdvertisingParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get single family customer account view property listing advertising
 */
export const useRentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising = (
  getParams: AdvertisingParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising.getKey =
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_GetKey;

export type RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_Options = UseQueryOptions<
  AccountViewListingsDto,
  unknown,
  AccountViewListingsDto,
  readonly [string, ListParams]
>;

const RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_GetKey = (getParams: ListParams) =>
  [RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_Path, getParams] as const;

export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_queryOptions = (
  getParams: ListParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramSingleFamilyWebApiHandler_list(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get single family customer account view property list
 */
export const useRentalManagerAccountViewZramSingleFamilyWebApiHandler_list = (
  getParams: ListParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZramSingleFamilyWebApiHandler_list.getKey =
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_GetKey;

export type RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_Options = UseQueryOptions<
  AccountViewListingOptionsDto,
  unknown,
  AccountViewListingOptionsDto,
  readonly [string, OptionsParams]
>;

const RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_GetKey = (getParams: OptionsParams) =>
  [RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_Path, getParams] as const;

export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_queryOptions = (
  getParams: OptionsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramSingleFamilyWebApiHandler_options(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get single family customer account view property listing options
 */
export const useRentalManagerAccountViewZramSingleFamilyWebApiHandler_options = (
  getParams: OptionsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZramSingleFamilyWebApiHandler_options.getKey =
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_GetKey;

export type RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_Options = UseQueryOptions<
  AccountViewListingProspectsDto,
  unknown,
  AccountViewListingProspectsDto,
  readonly [string, ProspectsParams]
>;

const RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_GetKey = (getParams: ProspectsParams) =>
  [RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_Path, getParams] as const;

export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_queryOptions = (
  getParams: ProspectsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get single family customer account view property prospects
 */
export const useRentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects = (
  getParams: ProspectsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects.getKey =
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_GetKey;

export type RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_Options = UseQueryOptions<
  AccountViewListingSourcesDto,
  unknown,
  AccountViewListingSourcesDto,
  readonly [string, SourcesParams]
>;

const RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_GetKey = (getParams: SourcesParams) =>
  [RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_Path, getParams] as const;

export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_queryOptions = (
  getParams: SourcesParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get single family customer account view property listing sources
 */
export const useRentalManagerAccountViewZramSingleFamilyWebApiHandler_sources = (
  getParams: SourcesParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZramSingleFamilyWebApiHandler_sources.getKey =
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_GetKey;

export type RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_Options = UseQueryOptions<
  AccountViewListingStatusOverviewDto,
  unknown,
  AccountViewListingStatusOverviewDto,
  readonly [string, StatusParams]
>;

const RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_GetKey = (getParams: StatusParams) =>
  [RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_Path, getParams] as const;

export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_queryOptions = (
  getParams: StatusParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramSingleFamilyWebApiHandler_status(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get single family customer account view property listing status
 */
export const useRentalManagerAccountViewZramSingleFamilyWebApiHandler_status = (
  getParams: StatusParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZramSingleFamilyWebApiHandler_status.getKey =
  RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_GetKey;
